// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#kpi[data-v-64acdb64]{background-color:#1b2445;box-sizing:border-box}#kpi[data-v-64acdb64],#kpi .box[data-v-64acdb64]{position:relative;width:100%;height:100%}#kpi element.style[data-v-64acdb64]{width:100%}", ""]);
// Exports
module.exports = exports;
